<template>
  <div class="contain">
    <van-list
        ref="check"
        :model="loading"
        :finished="finished"
        finished-text="没有更多了"
        offset="0"
        @load="queryAgentMessages"
      >
      <div class="list" v-for="(item, index) in msgList" @click="toDetail(item)">
        <div class="left">  
          <div class="titleContent">
            <div class="title">{{item.title}}</div>
            <div class="dot" v-if="item.msgStatus === 0"></div>
          </div>
          <div class="time">{{ item.createTimeStr ? item.createTimeStr.substr(0,10) : ''}}</div>
        </div>
        <div class="right"></div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { queryAgentMessages, agentMessagesRead } from "../../api/winterGame";
import { Toast } from "vant";

export default {
  computed: {},
  components: {
   
  },
  data() {
    return {
      currentCampusId:'',
      msgList:[],
      pageSize:10,
      pageNum:1,
      loading: false,
      finished: false,
      isLoadingData: false,
      msgId:''
    };
  },
  created() {
    document.title = this.$route.meta.title || "通知中心";
  },
  mounted() {
    this.setUserInfo();
  },
  methods: {
    toDetail(item){
      this.msgId = item.id
      // 点击时调整通知为已读
      this.agentMessagesRead()
      this.$router.push({
        path: "/winterGame/notDetail",
        query: { notData :JSON.stringify(item) },
      });
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentCampusId = userInfoId.campusId;
        this.queryAgentMessages()
      } else {
        Toast("找不到参赛信息");
      }
    },
    async queryAgentMessages() {
      if (this.isLoadingData) {
        return;
      }
      this.isLoadingData = true;
      try {
        let params = {
          param: {
            schoolId: this.currentCampusId,
            pageSize: this.pageSize,
            pageNum: this.pageNum
          },
        };
        let res = await queryAgentMessages(params);
        this.isLoadingData = false;
        if (res.code === 0) {
          if (res.data.body.length > 0) {
            this.msgList = [...this.msgList, ...res.data.body];
            this.pageNum = this.pageNum + 1;
          } else {
            this.finished = true;
          }
          this.loading = false;
        } else {
          Toast(res.message);
        }

      } catch (e) {
        Toast(e.message);
      }
      
    },
    async agentMessagesRead() {
      let params = {
          param: {
            msgId: this.msgId
          },
        };
        let res = await agentMessagesRead(params);
        if (res.code === 0) {
          // this.queryAgentMessages()
        } else {
          Toast(res.message);
        }
    },
  },
};
</script>


<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .contain {
    height: 100vh;
    overflow: auto;
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 32px;
      padding-bottom: 34px;
      border-bottom: 1px solid #E6E6E6;
      .left {
        .titleContent{
          display: flex;
          align-items: center;
          .title{
            width: 600px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #323232;
            line-height: 40px;
          }
          .dot {
            margin-left: 20px;
            width: 12px;
            height: 12px;
            background: #EE4B4E;
            border-radius: 50%;
          }
        }
    
        .time{
          margin-top: 8px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 40px;
        }
      }
    
      .right {
        width:20px;
        height:20px;
        border-top:3px solid #bbbbbb;
        border-right:3px solid #bbbbbb;
        transform: rotate(45deg);
      }
    }
  }
</style>
